(ns ui.completion.new-entity
  "Waiting until a just-created entity is actually usable by whatever runs next.

   \"Usable\" means different things depending on where the UI will read the
   entity back from, and the creator flows need both:

   - a **bulk-synced** type is read out of `@session/entities`, so the wait is
     for Datomic session sync - `current-session/wait-for-entity-sync!`.
   - everything else is read out of OpenSearch (the new grid and kanban both
     are), so the wait is for the search index. Session sync will never
     complete for those types - see `common.sync-model` - which is why
     `wait-for-entity-sync!` skips its wait entirely for them. Before
     completion messages existed there was nothing else to wait for, so it
     continued immediately and the caller raced the index: exactly the
     guarantee `c5bce82ddb` added and moving the indexing off the request
     thread gave up.

   This composes the two so a caller passes one `:on-processed!` and gets the
   right wait for the type it created."
  (:require
   [frontend.state.current-session :as session]
   [ui.completion.event :as completion-event]))

(defn wait-for-searchable!
  "Drop-in replacement for `current-session/wait-for-entity-sync!` as an
   `:on-processed!`, taking the same map plus `:completion-id`.

   `:completion-id` comes from the create response envelope and is threaded
   through by the creator's `create-success`. A `nil` one continues immediately,
   so a create endpoint that emits no completion id behaves exactly as it did
   before."
  [{:keys [new-entity-id new-entity completion-id close-cb!]}]
  (let [entity-type (:entity/type new-entity)]
    (if (and entity-type
             (not (session/bulk-synced-entity-type? entity-type)))
      (completion-event/await! {:completion-id completion-id
                                :continue!     close-cb!})
      (session/wait-for-entity-sync! {:new-entity-id new-entity-id
                                      :new-entity    new-entity
                                      :close-cb!     close-cb!}))))
